import {useState} from 'react';
import {useDetectionDamage} from '@/hooks/ai.hooks';

import _ from 'lodash';

import BannerImgText from '@/components/BannerImgText';
import Card from '@/components/Card';
import Modal from '@/components/Modal';
import FileUpload from '@/components/FileUpload';
import EmptyResult from '@/components/EmptyResult';

import {downloadBase64Image} from '@/utils/file.utils';

const DamageDetectionPage = () => {
  const [file, setFile] = useState<File>();
  const {mutate: mutateDetect, isPending, data} = useDetectionDamage();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: any = data; // I need to create the type for it.
  const resultFilter:[] = _.uniq(result?.data?.detected_classes) as [];

  const HandleDownloadFile = () => {
    if(file) downloadBase64Image(result.data.image, file.name);
  }
  return (
    <div className="container">
      <BannerImgText title="Détection des dommages" img="media/ia-images/car_damage.webp" />
      <div className="grid grid-cols-2 gap-3">
        <Card title="Séléction des fichiers">
          <div className="mb-5">
            <FileUpload setFileUpload={setFile}/>
          </div>
          <div className="text-center">
            <button className="btn btn-fill btn-primary justify-center w-auto min-w-20" onClick={() => mutateDetect(file)}>{isPending ? '...En Cours' : 'GO'  }</button>
          </div>
        </Card>
        <Card title="Dommages détecter">
          <div className={(result || isPending) ? 'hidden' : ''}>
            <EmptyResult text="Aucune analyse trouvé" />
          </div>
          {isPending && 
              <img  className="m-auto" src="./loading.svg"  />
          }
          {!isPending && data && (
            <div className={data ? '' : 'hidden'}>
              <div className="flex gap-2 mb-4">
                {resultFilter?.map((detect, index) => (
                  <span key={index} className="badge badge-lg badge-outline badge-danger">{detect}</span>
                ))}
              </div>
              <div className="flex gap-2">
                <button className="btn btn-fill btn-light" onClick={HandleDownloadFile}>
                  <i className="ki-filled ki-cloud-download"></i>
                  Télécharger le fichier
                </button>
                <button className="btn btn-primary btn-fill w-fit" data-modal-toggle="#modal-file-view">
                  <i className="ki-outline ki-eye">
                  </i>
                  Aperçu
                </button>
              </div>
            </div>
          )}
        </Card>
      </div>
      <Modal
        id="modal-file-view"
        title='Aperçu'
        showSecondBtn
        secondBtnLabel='Télécharger'
        size='large'
        onClickSecondBtn={HandleDownloadFile}
      >
        {!isPending && data &&
          <img className='m-auto' src={`data:image/jpeg;base64,${result.data.image}`}  />
        }
      </Modal>
    </div>
  );
}
  
export default DamageDetectionPage;